import { QueryList } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { PlantingInstructionsFormComponent } from './planting-instructions-form/planting-instructions-form.component';
var PlantingInstructionsComponent = /** @class */ (function () {
    function PlantingInstructionsComponent() {
    }
    Object.defineProperty(PlantingInstructionsComponent.prototype, "treatments", {
        get: function () {
            return this.experimentDesignFormGroup.get('treatments');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlantingInstructionsComponent.prototype, "numberOfSeedsPerCell", {
        get: function () {
            return this.experimentDesignFormGroup.get('numberOfSeedsPerCell');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlantingInstructionsComponent.prototype, "numberToPotsEnabled", {
        get: function () {
            return this.treatments.controls[0].get('plantingInstructions.numberToPots').enabled;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlantingInstructionsComponent.prototype, "numberToHarvestEnabled", {
        get: function () {
            return this.treatments.controls[0].get('plantingInstructions.numberToHarvest').enabled;
        },
        enumerable: true,
        configurable: true
    });
    PlantingInstructionsComponent.prototype.ngOnInit = function () {
    };
    PlantingInstructionsComponent.prototype.applyAll = function (sourceComponent) {
        var args = {
            numberToHarvest: sourceComponent.numberToHarvest,
            numberToPots: sourceComponent.numberToPots
        };
        this.plantingInstructionForms.forEach(function (f) { return f.copyValueFrom(args); });
    };
    return PlantingInstructionsComponent;
}());
export { PlantingInstructionsComponent };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/request-creation/experiment-design/planting-instructions/planting-instructions.component.ts.pre-build-optimizer.js